import { getUrlCad } from './staticValues';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { DadosDefaultService } from './../services/dados-default.service';
import { NetworkService } from './../services/network.service';
import { Subscription } from 'rxjs';
import { OnDestroy, EventEmitter, Output, ViewChild, Directive } from '@angular/core';

@Directive()
export class BaseForm implements OnDestroy {

    @Output() dadosSalvos = new EventEmitter()
    @ViewChild('conteudo') content: any
    hash = ''
    modal = false
    urlCadastro: any = ''

    constructor(public networkService: NetworkService, public dadosDefault: DadosDefaultService, public router: Router, public entidade: string, public messageService: MessageService) {
    }

    public save(endpoint: string, value: any, modal?: boolean, url = getUrlCad()) {
        this.clear()
        if (!value.Id || value.Id === 0) {
            this.networkService.salvar(url, endpoint, value).subscribe(v => {
                this.sair(v);
            })
        } else {
            this.networkService.atualizar(url, endpoint, value).subscribe(v => {
                this.sair(v);
            })
        }

    }

    public cancelar() {
        this.sair()
    }

    addSingleErrorMessage(msg: any) {
        this.messageService.add(msg);
    }

    clear() {
        this.messageService.clear();
    }

    private sair(value?: any) {
        if (this.modal) {
            this.dadosSalvos.emit({type: this.entidade, payload: value})
            this.dadosDefault.closeModal(this.hash);

        } else {
            this.router.navigate([`/${this.urlCadastro !== undefined ? this.urlCadastro : this.entidade}`])
        }
    }

    ngOnDestroy() {
       
    }

}
